
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.545 1a8.455 8.455 0 11-4.057 15.864L2.17 18.92a.818.818 0 01-1.09-1.09l2.056-4.318A8.444 8.444 0 0110.546 1zm0 1.636a6.807 6.807 0 00-5.79 10.404.818.818 0 01.044.784l-1.25 2.627 2.626-1.25a.818.818 0 01.784.043 6.817 6.817 0 009.038-9.903 6.818 6.818 0 00-5.45-2.705h-.003z","clip-rule":"evenodd"}})])
          )
        }
      }
    